/* LUGAZI: the walking cat keeps the old cat's body, legs and walk, but wears the face, the tufted tail and the body
   stripes from Leandro's notebook cat (BOOK page 3761). The theme still does all the walking, tail swish and paw
   licking - this file only swaps the picture and tells the theme where the new tail sits.
   Remove this file (and its two lines in snippets/lugazi-hints.liquid) to get the old cat back. */
(function () {
  var me = document.currentScript; if (!me || !me.dataset.cat) return;
  var SRC = me.dataset.cat;
  /* only the tail moves to a new place - legs and body keep the old cat's cut, so the walk is the old walk */
  var P = { 'lc-tail-clip': '1040,520 1376,520 1376,960 1180,960 1110,720 1040,710' };
  var css = document.createElement('style');
  css.textContent = '.lc-cat.lgz-cat2 .lc-tail{transform-origin:1040px 640px}';
  document.head.appendChild(css);

  var ready = false, failed = false, pre = new Image();
  pre.onload = function () { ready = true; scan(); };
  pre.onerror = function () { failed = true; scan(); };
  pre.src = SRC;

  function swap(cat) {
    var svg = cat.querySelector('svg.lc-cat-facing'); if (!svg) return;
    if (failed) { cat.classList.add('lgz-cat-old'); return; }      /* picture did not load: keep the old cat */
    /* the theme adds the tail later, so every look checks all parts again (cheap: a handful of elements) */
    Object.keys(P).forEach(function (id) {
      var poly = svg.querySelector('[id="' + id + '"] polygon');
      if (poly && poly.getAttribute('points') !== P[id]) poly.setAttribute('points', P[id]);
    });
    var m = svg.querySelector('[id="lc-body-no-tail"] polygon');
    if (m && m.getAttribute('points') !== P['lc-tail-clip']) m.setAttribute('points', P['lc-tail-clip']);
    svg.querySelectorAll('image').forEach(function (i) {
      if (i.getAttribute('href') !== SRC) { i.setAttribute('href', SRC); i.removeAttributeNS('http://www.w3.org/1999/xlink', 'href'); }
    });
    cat.classList.add('lgz-cat2');
  }
  function scan() {
    if (!ready && !failed) return;
    document.querySelectorAll('.lc-cat').forEach(swap);
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scan);
})();
